"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("../../components/utils/helpers");
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    root: {
      '& .Mui-disabled': {
        opacity: 0.5
      },
      '& .MuiRadio-root': {
        borderRadius: '21px',
        height: '40px',
        left: '50%',
        position: 'absolute',
        transform: 'translateX(-50%)',
        width: '100%'
      },
      '& .MuiRadio-root + .MuiFormControlLabel-label': {
        border: '2px solid transparent',
        borderRadius: '21px',
        'box-shadow': isHighContrast ? '0px 2px 2px #fff' : '0px 2px 2px #00000019',
        color: isHighContrast ? _helpers.agentDeveloperUtils.getSecondaryColor(100) : _helpers.agentDeveloperUtils.getSecondaryColor(300),
        fontSize: isFontBigger ? '20px' : '16px',
        fontWeight: 'bold',
        lineHeight: '22px',
        margin: 0,
        padding: '9px 20px'
      },
      '& .MuiRadio-root input': {
        height: '16px',
        width: '16px'
      },
      '& .MuiRadio-root svg': {
        display: 'none'
      },
      '& .MuiRadio-root.Mui-checked + .MuiFormControlLabel-label': {
        borderColor: isHighContrast ? _helpers.agentDeveloperUtils.getPrimaryColor(300) : _helpers.agentDeveloperUtils.getPrimaryColor(450),
        borderWidth: isHighContrast ? '3px' : '2px'
      },
      marginLeft: 0,
      marginRight: '15px',
      position: 'relative'
    }
  };
};
exports.default = _default;